import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["yes", "no"]
    static values = { lineItemId: Number, performanceId: Number }

    connect() {
        this.checkoutButton = document.querySelector(".checkout.button")
        this.updateCheckoutButton()
        this.checkoutButton.addEventListener("click", (event) => {
            if (this.checkoutButton.classList.contains("disabled-button")) {
                this.changeBorderColor()
            }
        })
        this.yesTarget.addEventListener("click", () => {
            this.updateCheckoutButton()
            this.changeBorderColor()
            this.createTicketProtection()
        })
        this.noTarget.addEventListener("click", () => {
            this.updateCheckoutButton()
            this.changeBorderColor()
            this.removeTicketProtection()
        })
    }

    updateCheckoutButton() {
        if (!this.checkoutButton) {
            return
        }

        const selectionMade = (this.yesTarget && this.yesTarget.checked) || (this.noTarget && this.noTarget.checked)

        if (selectionMade) {
            this.checkoutButton.classList.remove("disabled-button")
            this.checkoutButton.removeAttribute("aria-disabled")
            this.checkoutButton.setAttribute("href", "/orders")
        } else {
            this.checkoutButton.classList.add("disabled-button")
            this.checkoutButton.setAttribute("aria-disabled", "true")
            this.checkoutButton.removeAttribute("href")
        }
    }

    createTicketProtection() {
        fetch("/ticket_protection/create", {
            method: "POST",
            headers: {
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
            },
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("We're sorry, something went wrong. Please try again later.");
                }
                return response.json();
            })
            .then(data => {
                this.updateData(data);
            })
            .catch(error => {
                const errorDiv = document.querySelector('.error');
                if (errorDiv) {
                    errorDiv.textContent = error.message;
                }
            });
    }

    removeTicketProtection() {
        const formBody = new FormData();
        formBody.append("line_item_id", this.lineItemIdValue);
        formBody.append("performance_id", this.performanceIdValue);
        formBody.append('request_by', 'stimulus')
        fetch("/ticket_protection/destroy", {
            method: "DELETE",
            headers: {
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
            },
            body: formBody
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("We're sorry, something went wrong. Please try again later.");
                }
                return response.json();
            })
            .then(data => {
                this.updateData(data);
            })
            .catch(error => {
                const errorDiv = document.querySelector('.error');
                if (errorDiv) {
                    errorDiv.textContent = error.message;
                }
            });
    }

    updateData(data) {
        const subtotalElement = document.querySelector(".subtotal .amount");
        const totalElement = document.querySelector(".total .amount");
        this.lineItemIdValue = data.line_item_id;
        this.performanceIdValue = data.performance_id;

        if (subtotalElement) {
            subtotalElement.textContent = data.subtotal;
        }
        if (totalElement) {
            totalElement.textContent = data.total;
        }
    }

    changeBorderColor() {
        if (this.yesTarget.checked) {
            document.querySelector(".add-ticket-protection.border-box").classList.remove("red")
            document.querySelector(".add-ticket-protection.border-box").classList.add("green")
            document.querySelector(".do-not-add-ticket-protection.border-box").classList.remove("red")
            document.querySelector(".required-text").classList.add("visually-hidden")
        } else if (this.noTarget.checked) {
            document.querySelector(".do-not-add-ticket-protection.border-box").classList.add("red")
            document.querySelector(".add-ticket-protection.border-box").classList.remove("green")
            document.querySelector(".add-ticket-protection.border-box").classList.remove("red")
            document.querySelector(".required-text").classList.add("visually-hidden")
        } else {
            document.querySelector(".add-ticket-protection.border-box").classList.remove("green")
            document.querySelector(".do-not-add-ticket-protection.border-box").classList.add("red")
            document.querySelector(".add-ticket-protection.border-box").classList.add("red")
            document.querySelector(".required-text").classList.remove("visually-hidden")
        }
    }


}
